import * as React from "react";
import Link from "@mui/material/Link";
import Divider from "@mui/material/Divider";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";


import PhotoAlbum from "react-photo-album";
import Lightbox from "yet-another-react-lightbox";

import photos from "./photos.js";
import slides from "./slides.js";

import './App.css'
import "yet-another-react-lightbox/styles.css";


export default function PhotoGallery() {
  const [index, setIndex] = React.useState(-1);

  return (
    <>
      <PhotoAlbum
        layout="rows"
        photos={photos}
        targetRowHeight={150}
        onClick={({ index }) => setIndex(index)}
      />

      <Lightbox
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        slides={slides}
      />
    </>
  );
}
